import { useState } from 'react';
import styled from 'styled-components';
import { TextArea } from 'ui/inputs';
import { Divider } from 'ui/divider';
import { BUTTON_SIZES, GhostButton } from 'ui/button';
import { Modal, ModalBody, ModalHeader } from 'ui/modal';
import { CatalogCsvUploader } from 'modules/catalogForm/components/CatalogCsvUploader';
import { Body1, Body2 } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { ExampleUserList } from './components/table/ExampleUserList';

const StyledGhostButton = styled(GhostButton)`
  margin-left: 77%;
`;

const StyledBody2 = styled(Body2)`
  padding-left: ${pxToRem(24)};
`;

const StyledDivider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: ${pxToRem(30)};
  padding-bottom: ${pxToRem(30)};
  font-size: 12px;
  &::before,
  &::after {
    content: '';
    display: block;
    height: ${pxToRem(1)};
    width: 100%;
    background-color: #717171;
  }
  span {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const CVSUploadArea = styled.div`
  &.emptyInput {
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const TextInputArea = styled.div`
  &.emptyInput {
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

interface Panel2Page {
  csvUploadInput: string;
  updateCSVUploadInput: (value: string) => void;
  setCSVFileName: (value: string) => void;
  setCSVFileSize: (value: string) => void;
  csvTextInput: string;
  updateCSVTextInput: (value: string) => void;
}

export function Panel2Content({
  csvUploadInput,
  updateCSVUploadInput,
  setCSVFileName,
  setCSVFileSize,
  csvTextInput,
  updateCSVTextInput,
}: Panel2Page) {
  const [modalActive, setModalActive] = useState(false);

  function readCSVfile(evt: { files: File[] }) {
    const { files } = evt;

    const f = files[0];

    const reader = new FileReader();

    reader.onload = (e) => {
      if (e.target?.result) {
        updateCSVUploadInput(e.target.result.toString());
      }
    };

    reader.readAsText(f);

    setCSVFileName(f.name);
    setCSVFileSize(f.size.toString().concat(' Bytes'));
  }

  return (
    <div>
      <StyledGhostButton
        size={BUTTON_SIZES.LARGE}
        onClick={() => {
          setModalActive(!modalActive);
        }}
      >
        GET HELP WITH CSV FORMATTING...
      </StyledGhostButton>

      <Divider />

      {modalActive && (
        <Modal
          id="modal"
          isModalOpen
          onClose={() => {
            setModalActive(!modalActive);
          }}
          size="large"
        >
          <ModalHeader>Select a CSV file or copy & paste your CSV data</ModalHeader>
          <StyledBody2>
            Make sure you have a column named email, or only contain 1 column of emails
          </StyledBody2>
          <ModalBody>
            Example User List
            <ExampleUserList />
          </ModalBody>
        </Modal>
      )}

      <CVSUploadArea className={csvTextInput ? 'emptyInput' : 'disabled'}>
        <CatalogCsvUploader
          isCatalogCollectionsFlagOn={true}
          rowData={[]}
          columnData={[]}
          onCsvPreview={readCSVfile}
        />
      </CVSUploadArea>

      <StyledDivider>
        <span>OR</span>
      </StyledDivider>

      <TextInputArea className={csvUploadInput ? 'emptyInput' : 'disabled'}>
        <Body1>Textarea Input</Body1>

        <TextArea
          id="CSVTextInput"
          isCharacterCountShown={true}
          onChange={updateCSVTextInput}
          placeholder="Email, First Name, Last Name"
          value={csvTextInput}
        />
      </TextInputArea>
    </div>
  );
}
